<div class="container">
  <div class="nav-grid">
    <div class="nav-grid__item">
      <div class="nav">
        <strong class="nav__title text-gradient">{{ 't.casino' | translate }}</strong>
        <a class="nav__item" [routerLink]="['/', lang, 'games', 'slots']">{{ 'link.slots' | translate }}</a>
        <a class="nav__item" [routerLink]="['/', lang, 'games', 'fast-play']">{{ 'link.fast-play' | translate }}</a>
        <a  class="nav__item" [routerLink]="['/', lang, 'games', 'jackpot']">{{ 'link.jackpot-games' | translate }}</a>
        <a class="nav__item" [routerLink]="['/', lang, 'games', 'live']">{{ 'link.live' | translate }}</a>
        <a class="nav__item" [routerLink]="['/', lang, 'games', 'table']">{{ 'link.table-games' | translate }}</a>
        @if (bonusStore.bonusStorePage$ | async) {
          <a class="nav__item" [routerLink]="['/', lang, 'bonus-shop']">{{ 'link.bonus-shop' | translate }}</a>
        }
      </div>
    </div>

    <div class="nav-grid__item">
      <div class="nav">
        <strong class="nav__title text-gradient">{{ 'link.live-casino' | translate }}</strong>
        <a [routerLink]="['/', lang, 'games', 'blackjack']" class="nav__item">{{ 'link.blackjack' | translate }}</a>
        <a [routerLink]="['/', lang, 'games', 'roulette']" class="nav__item">{{ 'link.roulette' | translate }}</a>
        <a [routerLink]="['/', lang, 'games', 'baccarat']" class="nav__item">{{ 'link.baccarat' | translate }}</a>
        <a [routerLink]="['/', lang, 'games', 'live-shows']" class="nav__item">{{ 'link.live-shows' | translate }}</a>
      </div>
    </div>

    <div class="nav-grid__item">
      <div class="nav">
        <strong class="nav__title text-gradient">{{ 't.about-categ-t' | translate }}</strong>
        <a [routerLink]="['/', lang, 'about']" class="nav__item">{{ 'link.about-us' | translate }}</a>
        <a [routerLink]="['/', lang, 'faq']" class="nav__item">{{ 'link.faq' | translate }}</a>
        <a [routerLink]="['/', lang, 'banking']" class="nav__item">{{ 'link.banking' | translate }}</a>
        <a [routerLink]="['/', lang, 'terms-and-conditions']" class="nav__item">{{ 'link.terms-and-cond' | translate }}</a>
        <a [routerLink]="['/', lang, 'bonus-terms']" class="nav__item">{{ 'link.bonus-terms' | translate }}</a>
        <a [routerLink]="['/', lang, 'responsible-gaming']" class="nav__item">{{ 'link.responsible-gaming' | translate }}</a>
      </div>
    </div>

    <div class="nav-grid__item">
      <div class="nav">
        <strong class="nav__title text-gradient">{{ 'link.contact-us' | translate }}</strong>
        <a [routerLink]="['/', lang, 'contacts']" class="nav__item">{{ 'link.contact-support' | translate }}</a>
        <a [routerLink]="['/', lang, 'privacy-policy']" class="nav__item">{{ 'link.privacy-policy' | translate }}</a>
        <a [routerLink]="['/', lang, 'cookie-policy']" class="nav__item">{{ 'link.cookie-policy' | translate }}</a>
        <a href="https://www.newgenaffiliates.com" rel="noopener" target="_blank" class="nav__item">{{ 'link.becom-aff' | translate }}</a>
        @if (!installApp?.isNativeApp) {
          <a [routerLink]="['/', lang, 'mobile-app']" class="nav__item">{{ 'link.install-app' | translate }}</a>
        }
      </div>
    </div>
  </div>
</div>
